import apiClient from './ApiService'

export default {
  login(credentials) {
    console.log('AuthService login called with:', credentials)
    return apiClient.post('/auth/login', credentials)
  },
  
  forgotPassword(email) {
    return apiClient.post('/auth/forgot-password', { email })
  },
  
  resetPassword(token, password) {
    return apiClient.post(`/auth/reset-password/${token}`, { password })
  },
  
  changePassword(currentPassword, newPassword) {
    return apiClient.post('/auth/change-password', { currentPassword, newPassword })
  },
  
  getProfile() {
    return apiClient.get('/auth/profile')
  },
  
  updateProfile(userId, profileData) {
    return apiClient.put(`/usuarios/${userId}`, profileData)
  }
}